"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var __1 = require("../..");
var context_1 = require("../../../context");
var SectionHeading_1 = __importDefault(require("../../SectionHeading"));
var CarersDetailsProfile = function (_a) {
    var client = _a.client;
    var trans = context_1.useSemantics().trans;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SectionHeading_1.default, { className: "pb-8", heading: trans('optiiva::headings.carers'), subHeading: trans('optiiva::headings.personal') }),
        react_1.default.createElement(__1.DataRow, { horizontal: true, label: trans('optiiva::labels.phone-number'), value: client.carers_name || trans('optiiva::misc.empty-line') }),
        react_1.default.createElement(__1.DataRow, { horizontal: true, label: trans('optiiva::labels.phone-number'), value: client.carers_phone_number || trans('optiiva::misc.empty-line') }),
        react_1.default.createElement(__1.DataRow, { horizontal: true, label: trans('optiiva::labels.email'), value: client.carers_email || trans('optiiva::misc.empty-line') }),
        react_1.default.createElement(__1.DataRow, { horizontal: true, label: trans('optiiva::labels.carers-consent-to-contact'), value: client.carers_consent_to_contact_readable || trans('optiiva::misc.empty-line') })));
};
exports.default = CarersDetailsProfile;
//# sourceMappingURL=CarersDetailsProfile.js.map